import { buildHubAsync } from "./signalR.js";

function logConnectionEvents(connection, eventName) {
	connection.on(eventName, () => console.log(`SignalR Event: ${eventName}`));
}
// Public
export async function buildPdfAnnotationsHubAsync(hubConfig, notarizationId, documentId) {
	const connection = await buildHubAsync(window.Notary.Config.Hubs.PdfAnnotations, hubConfig, `${notarizationId}/${documentId}`);

	if (hubConfig.debugLog) {
		logConnectionEvents(connection, `Update`);
	}

	if (hubConfig.onUpdate) {
		connection.on(`Update`, hubConfig.onUpdate);
	}

	return connection;
}
